import {
  ActionIcon,
  Badge,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  Group,
  Input,
  Menu,
  NumberFormatter,
  Select,
  SelectProps,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconBrandBootstrap,
  IconBuildingSkyscraper,
  IconCheck,
  IconCoinPound,
  IconDownload,
  IconEye,
  IconReceipt,
  IconSearch,
  IconStatusChange,
  IconTicket,
  IconTimeDuration15,
  IconTrash,
  IconUser,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_ColumnFiltersState,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import * as React from "react";
import { useEffect, useState } from "react";

import { DatePickerInput } from "@mantine/dates";
import {
  useDebouncedCallback,
  useIsFirstRender,
  useMediaQuery,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import {
  keySearchRequestListReceipts,
  repositoryMdm,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { formatDateTransfer } from "../../../../common/FormatDate/FormatDate";
import { SaveKeySearch } from "../../../../common/SaveKeySearch/SaveKeySearch";
import useWindowSize from "../../../../common/WindownSize/WindownSize";
import { BASE_API_POS } from "../../../../config";
import { _localization } from "../../../../config/location";
import {
  green,
  olive_green,
  orange,
  purple,
  sky_blue,
} from "../../../../const/variables";
import { MessageResponse } from "../../../../model/MessageResponse";
import { PaymentReceiptDetailModel } from "../../../../model/PaymentReceiptDetailModel";
import { SelectListItem } from "../../../../model/SelectListItem";

import { useForm } from "@mantine/form";
import moment from "moment";
import OrderList from "./OrderList/OrderList";
import { OrderDetail } from "./OrderDetail/OrderDetail";

interface DataList {
  lists: any[];
  count: number;
}

interface DocumentInfo {
  id: number;
  code: string;
  originalDocuments: string;
  originalDocumentNumber: string;
  codeForFees: string;
  occurringCredit: string;
  debtObjectCode: string;
  debtObjectName: string;
  employeeFund: string;
  branchesFund: string;
  description: string;
  departmentFund: string;
  fee: string;
  contract: string;
  stt: number;
  orderNumber: string;
  attribute2: string;
  attribute7: string;
  amountTotal: number;
  amountPaid: number;
  amountRemaining: number;
  allocatedAmount: number;
  note: string;
  codeBranch: string;
}

// Interface cho danh sách thứ hai
interface DocumentProps {
  document: DocumentInfo;
}

interface DepartmentCustomerOrder {
  id: number;
  name: string;
  details: {
    fullName: string;
    phoneNumber: string;
  };
}

interface DepartmentUser {
  departmentId: number;
  name: string;
  description: string | null;
  active: boolean;
  departmentCode: string;
  creationDate: string;
  createdBy: string;
  lastUpdateDate: string | null;
  lastUpdatedBy: string | null;
  address: string;
  branchId: number;
}

interface Program {
  id: number;
  code: string;
  name: string;
  createBy: string | null;
  createDate: string;
  lastUpdateDate: string | null;
  lastUpdateBy: string | null;
}

interface Permission {
  id: number;
  code: string;
  name: string;
  createBy: string | null;
  createDate: string;
  lastUpdateDate: string | null;
  lastUpdateBy: string | null;
}

interface AddressInfo {
  active: boolean;
  address: string;
  birthOfDate: string;
  code: string;
  buyerName: string;
  commune: number;
  companyName: string | null;
  contact: string | null;
  country: string | null;
  debtLimit: number | null;
  description: string | null;
  district: number;
  email: string;
  fax: string | null;
  groupId: number;
  groupName: string;
  id: number;
  name: string;
  province: number;
  sex: number;
  taxCode: string | null;
  tblDmCustomerGroupModel: any | null;
  telephoneNumber: string;
  type: number;
}

interface Customer {
  addr: string;
  createdBy: number;
  creationDate: string;
  creditLimit: number;
  email: string;
  employeeId: number;
  enabledFlag: boolean | null;
  endDateActive: string;
  id: number;
  orgId: number;
  phone: string;
  startDateActive: string;
  vatRegistrationNum: string;
  vendorCode: string;
  vendorName: string;
  vendorTypeLookupCode: string;
}
interface Customer {
  addr: string;
  createdBy: number;
  creationDate: string;
  creditLimit: number;
  email: string;
  employeeId: number;
  enabledFlag: boolean | null;
  endDateActive: string;
  id: number;
  orgId: number;
  phone: string;
  startDateActive: string;
  vatRegistrationNum: string;
  vendorCode: string;
  vendorName: string;
  vendorTypeLookupCode: string;
}

interface User {
  id: number;
  code: string;
  fullname: string;
  dateOfBirth: string;
  gender: number;
  departmentId: number | null;
  departmentName: string | null;
  roleId: number;
  roleName: string;
  managerName: string | null;
  address: string | null;
  phoneNumber: string;
  active: boolean;
  email: string;
  description: string | null;
  accountingCenterId: number | null;
  managerId: number | null;
  isCrm: boolean | null;
  currentCardId: number;
  partCode: string | null;
  createDate: string;
  listBranch: string | null;
  listInventory: string | null;
  listGroup: string;
  branchId: number;
  branchName: string;
  workAddress: string | null;
}

const NewspaperListAvailable = () => {
  const navigate = useNavigate();
  //#region  table
  //data and fetching state
  const [data, setData] = useState<PaymentReceiptDetailModel[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataBranch, setDataBranch] = useState<SelectListItem[]>([]);
  const [dataFetch, setDataFetch] = useState<SelectListItem[]>([]);
  const [dataWarehouse, setDataWarehouse] = useState<SelectListItemBase[]>([]);
  // const [handleType, setHandeValueType] = useState<string>("");
  const [dataListCustomer, setDataListCustomer] = useState<SelectListItem[]>(
    []
  );
  const [addressInfoDetail, setAddressInfo] = useState<AddressInfo[]>([]);
  const [customerOrders, setCustomerOrders] = useState<
    DepartmentCustomerOrder[]
  >([]);
  const [branchAll, setBranchAll] = useState<DepartmentUser[]>([]);
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const [dataGetReceiptContract, setDataGetReceiptContract] = useState<
    Program[]
  >([]);
  const [selectedValue, setSelectedValue] = useState<string | null>(null);
  const [selectedCustomer, setSelectedCustomer] = useState<string | null>(null);
  const [typeHande, setTyleHandle] = useState<number>();
  const [loading, setLoading] = useState<boolean>(false);
  const [skip, setSkip] = useState<number>(1);
  const [take, setTake] = useState<number>(30);
  const [searchTerm, setSearchTerm] = useState<string>("");
  //table state
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [columnFilters, setColumnFilters] = useState<MRT_ColumnFiltersState>(
    []
  );
  // const [typeKey, settypeKey] = useState<number | null>(null);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [height, setHeight] = useState(0);
  //
  const [dataGetReceiptFee, setDataReceiptFee] = useState<Permission[]>([]);
  const [customerDetail, setCustomerDetail] = useState<Customer[]>([]);
  const debounceTimeoutRef = React.useRef<number | null>(null);
  const [value, setValue] = useState<[Date | null, Date | null]>([null, null]);
  const [dataCodeFund, setDataCodeFunch] = useState<SelectListItemBase[]>([]);
  const [dataBranchs, setDataBranchs] = useState<SelectListItemBase[]>([]);
  const firstRender = useIsFirstRender();
  const orderStatuses = [
    { value: "DON_HANG_TAM", label: "Đơn hàng tạm" },
    { value: "DON_HANG_CHOT", label: "Đơn hàng chốt" },
    { value: "DON_HANG_CHO_DUYET_GIAM", label: "Đơn chờ duyệt giảm" },
    { value: "DON_HANG_DA_DUYET_GIAM", label: "Đơn đã duyệt giảm" },
    { value: "DON_CHO_DUYET_DOI_TRA", label: "Đơn chờ duyệt đổi trả" },
    { value: "DON_DA_DUYET_DOI_TRA", label: "Đơn đã duyệt đổi trả" },
    { value: "DON_HANG_HUY", label: "Đơn hàng hủy" },
    { value: "DON_HANG_HOAN_THANH", label: "Đơn hàng hoàn thành" },
    { value: "DON_HANG_DONG", label: "Đơn hàng đóng" },
  ];

  const size = useWindowSize();

  // const [search, setSearch] = useState({
  //   keySearch: "",
  //   customerId: "",
  //   StartDate: "",
  //   EndDate: "",
  //   codefund: "",
  //   accountfund: "",
  //   department: "",
  //   branch: "",
  //   type: "",
  //   workplace: "",
  //   creator: "",
  //   Type: 0,
  //   typeReceipt: "",
  // });

  const [keySearch, setKeySearch] = useState<string>("");
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const sizeGrid = { base: 6, sm: 6, md: 4, lg: 4, xl: 2 };

  // const searchRef = React.useRef(search);
  const _searchJson = localStorage.getItem(keySearchRequestListReceipts)
    ? JSON.parse(localStorage.getItem(keySearchRequestListReceipts) ?? "")
    : null;

  const innitStateSearch = React.useMemo(
    () => ({
      keySearch:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.KeySearch
          : "",
      CustomerId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.CustomerId as string)
          : "",
      StartDate:
        firstRender && _searchJson && checkedPinSearch && _searchJson.StartDate
          ? new Date(_searchJson.StartDate)
          : new Date(new Date().setMonth(new Date().getMonth() - 1)),
      EndDate:
        firstRender && _searchJson && checkedPinSearch && _searchJson.EndDate
          ? new Date(_searchJson.EndDate)
          : new Date(),
      Codefund:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Codefund as string)
          : "",
      Accountfund:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Accountfund as string)
          : "",
      Department:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Department as string)
          : "",
      Branch:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Branch as string)
          : "",
      Type:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Type as string)
          : "",
      Workplace:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Workplace as string)
          : "",
      Creator:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Creator as string)
          : "",
      TypeReceipt:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.TypeReceipt as string)
          : "",
      OrderStatus:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.OrderStatus as string)
          : "",
    }),
    [firstRender, _searchJson]
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);

    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;

    try {
      const search = form.getValues();
      queryParams = {
        ...queryParams,
        // Skip: pagination.pageIndex * pagination.pageSize,
        // Take: pagination.pageSize,
        CustomerId: search.CustomerId ? search.CustomerId.toString() : "",
        StartDate: search.StartDate
          ? moment(search?.StartDate).format("MM/DD/YYYY")
          : "",
        EndDate: search.EndDate
          ? moment(search?.EndDate).format("MM/DD/YYYY")
          : "",
        KeySearch: search.keySearch
          ? (search.keySearch || keySearch).toLowerCase()
          : "",
        Codefund: search.Codefund ? search.Codefund.toString() : "",
        Accountfund: search.Accountfund ? search.Accountfund.toString() : "",
        Creator: search.Creator ? search.Creator.toString() : "",
        Workplace: search.Workplace ? search.Workplace.toString() : "",
        Branch: search.Branch ? search.Branch.toString() : "",
        Type: search.Type ? search.Type.toString() : "",
        TypeReceipt: search.TypeReceipt ? search.TypeReceipt.toString() : "",
        Department: search.Department ? search.Department.toString() : "",
        OrderStatus: search.OrderStatus ? search.OrderStatus.toString() : "",
      };
      // const queryParams = {
      //   Skip: pagination.pageIndex * pagination.pageSize,
      //   Take: pagination.pageSize,
      //   CustomerId: search.customerId,
      //   StartDate: search.StartDate,
      //   EndDate: search.EndDate,
      //   KeySearch: (search.keySearch || keySearch).toLowerCase(),
      //   Codefund: search.codefund,
      //   Accountfund: search.accountfund,
      //   Creator: search.creator,
      //   Workplace: search.workplace,
      //   Branch: search.branch,
      //   Type: search.type || search.Type,
      //   TypeReceipt: search.typeReceipt,
      //   Department: search.department,
      // };

      let sortingQuery = "";
      if (sorting && sorting.length > 0) {
        const { id, desc } = sorting[0] || {};
        if (id) {
          sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
        }
      }

      const url =
        Object.entries(queryParams).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== "") {
            return `${acc}&${key}=${encodeURIComponent(value as string)}`;
          }
          return acc;
        }, "/api/v1/CreateSellItem/list-receipt?IsBcAll=true") + sortingQuery;

      const response = await repositoryPos.get<MessageResponse<DataList>>(url);

      if (response && response.success) {
        const dataList = response?.data;
        setData(dataList?.lists);
        setRowCount(dataList?.count);
        // await dataOrderTypeSelect();
        setSelectIds([]);
        table.resetRowSelection();
      }
    } catch (error) {
      setIsError(true);
      console.error(error);
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      localStorage.setItem(
        keySearchRequestListReceipts,
        JSON.stringify(queryParams)
      );
    }
  };

  // Hàm gọi API phòng ban
  const fetchDataSelect = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDepartment/get-select"
    );

    if (dataApi && dataApi.success) {
      setDataFetch(dataApi.data);
    }
  };
  // Hàm gọi API chi nhánh
  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  const fetchDataWarehouse = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmEmployee/get-select"
    );

    if (dataApi && dataApi.success) {
      setDataWarehouse(dataApi.data);
    }
  };

  const getTblDmExpense = async () => {
    const response = await repositoryMdm.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmExpense/get-select");

    if (response && response.success) {
      let result = response.data;
      setDataCodeFunch(result);
    }
  };

  // const fetchDataReceiptFee = async () => {
  //   const response = await repositoryPos.get<MessageResponse<Permission[]>>(
  //     "/api/v1/TblDmFee/get-list?Skip=0&Take=9999"
  //   );

  //   if (response && response.success) {
  //     let result = response.data;
  //     setDataReceiptFee(result);
  //   }
  // };

  const fetchDataGetAll = async () => {
    try {
      const response = await repositoryPos.get<
        MessageResponse<DepartmentUser[]>
      >(`/api/v1/TblDepartment/get-all`);

      if (response && response.success) {
        const result = response.data;
        setBranchAll(result);
      } else {
        console.error("Failed to fetch departmentFund details");
      }
    } catch (error) {
      console.error("Error fetching departmentFund details", error);
    }
  };

  // const fetchDataReceiptContract = async () => {
  //   const response = await repositoryPos.get<MessageResponse<Program[]>>(
  //     "/api/v1/TblDmContract/get-list?Skip=0&Take=99999"
  //   );

  //   if (response && response.success) {
  //     let result = response.data;
  //     setDataGetReceiptContract(result);
  //   }
  // };

  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    getTblDmExpense();
    fetchDataGetAll();
    // fetchDataReceiptFee();
    fetchDataWarehouse();
    // fetchDataReceiptContract();
  }, []);

  // const handleChangeSearchValue1 = (value: string, key: string) => {
  //   if (key === "customerId") {
  //     setSelectedCustomer(value);
  //   }
  //   setSearch((prevData) => ({ ...prevData, [key]: value }));
  //   setSelectedValue(value);
  // };

  // const handleChangeSearchValue = useDebouncedCallback(
  //   (value: string, key: string) => {
  //     if (key === "customerId") {
  //       setSelectedCustomer(value);
  //     }
  //     setSearch((prevData) => ({ ...prevData, [key]: value }));
  //     setSelectedValue(value);
  //   },
  //   500
  // );

  // const handleRangeChange = (dates: [Date | null, Date | null]) => {
  //   console.log(dates);
  //   setValue(dates);
  //   const [StartDate, EndDate] = dates;
  //   const startDateISO = StartDate ? StartDate.toLocaleDateString() : null;
  //   const endDateISO = EndDate ? EndDate.toLocaleDateString() : null;

  //   handleChangeSearchValue(startDateISO ?? "", "StartDate");

  //   handleChangeSearchValue(endDateISO ?? "", "EndDate");
  // };

  const openModal = (document: PaymentReceiptDetailModel) =>
    modals.openConfirmModal({
      title: (
        <Title order={4}>
          Xem chi tiết chứng từ trong phiếu: {document.receiptNumber}
        </Title>
      ),
      children: <OrderDetail document={document} />,
      size: "100%",
      radius: "md",
      labels: { confirm: "Confirm", cancel: "Cancel" },
      onCancel: () => console.log("Cancel"),
      onConfirm: () => console.log("Confirmed"),
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });

  const parseAttribute5Data = (row: any) => {
    try {
      const parsedData = row.attribute5 ? JSON.parse(row.attribute5) : [];
      return Array.isArray(parsedData) ? parsedData : [];
    } catch {
      return [];
    }
  };

  const getTextStatus = (row: any) => {
    return orderStatuses.find(
      (status) => status.value === row.original.orderStatus
    )?.label;
  };

  const [environment, setEnvironment] = useState<string | undefined>("");

  useEffect(() => {
    const envvv = window.location.hostname.includes("pos.hacom.vn")
      ? "production"
      : "development";
    setEnvironment(envvv);
  }, []);

  const columns = React.useMemo<MRT_ColumnDef<PaymentReceiptDetailModel>[]>(
    () => [
      {
        header: "STT",
        accessorKey: "STT",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        Cell: ({ row }) => <>{row?.index + 1}</>,
        size: 50,
      },
      {
        accessorKey: "receiptNumber",
        enableColumnActions: false,
        header: "Mã phiếu thu",
        size: 150,
        Cell: ({ renderedCellValue, cell, row }) => {
          //    settypeKey(row.original.type);
          return (
            <Tooltip label="Xem chi tiết">
              <Badge
                radius="sm"
                variant="dot"
                size="md"
                style={{ cursor: "pointer" }}
                color={renderedCellValue === null ? "red" : green.base}
                onDoubleClick={async () => {
                  navigate("/bill/detail-payment-receipt", {
                    state: {
                      id: row.original.id,
                      type: row.original.type,
                      receptype: row.original.typeReceipt,
                    },
                  });
                  // detailReceipts(row.original.id, row.original.type);
                }}
              >
                {renderedCellValue}
              </Badge>
            </Tooltip>
          );
        },
      },
      {
        accessorKey: "attribute14",
        header: "Loại tạo",
        size: 120,
        enableColumnActions: false,
        Cell: ({ row, renderedCellValue }) => (
          <>
            <Badge
              size="sm"
              bd={`1px solid ${
                renderedCellValue === "1" ? "violet" : "orange"
              }`}
              variant="light"
              color={renderedCellValue === "1" ? "violet" : "orange"}
            >
              {renderedCellValue === "1" ? "Tự động" : "Thủ công"}
            </Badge>
          </>
        ),
      },
      {
        header: "Thời gian",
        id: "thoigian",
        mantineTableHeadCellProps: () => {
          return {
            style: {
              backgroundColor: "#f1f3f5",
            },
          };
        },
        columns: [
          {
            accessorKey: "createdDate",
            enableColumnActions: false,
            header: "Thời gian tạo ",
            size: 140,
            Cell: ({ renderedCellValue }: any) => (
              <>{formatDateTransfer(renderedCellValue)}</>
            ),
          },
          {
            accessorKey: "completiontime",
            enableColumnActions: false,
            size: 170,
            header: "Thời gian hoàn thành ",
            Cell: ({ renderedCellValue }: any) => (
              <>{formatDateTransfer(renderedCellValue)}</>
            ),
          },
        ],
      },
      // {
      //   accessorKey: "type",
      //   enableColumnActions: false,
      //   header: "Loại phiếu thu / chi",
      //   Cell: ({ row }) => {
      //     const renderBadge = () => {
      //       const { typeReceipt, type } = row.original;

      //       if (type === 3) {
      //         return (
      //           <Badge size="sm" color="gray">
      //             Phiếu báo nợ
      //           </Badge>
      //         );
      //       } else if (type === 4) {
      //         return (
      //           <Badge size="sm" color="#9D3BC7" c="#fff">
      //             Báo có
      //           </Badge>
      //         );
      //       } else if (typeReceipt === 1) {
      //         if (type === 1) {
      //           return (
      //             <Badge size="sm" color="#C3FF36" c="#000">
      //               Thu đơn hàng
      //             </Badge>
      //           );
      //         } else if (type === 6) {
      //           return (
      //             <Badge size="sm" color="yellow" c={"#000"}>
      //               Báo có đơn hàng
      //             </Badge>
      //           );
      //         }
      //         return (
      //           <Badge size="sm" color="#FF8800">
      //             Thu khác
      //           </Badge>
      //         );
      //       } else if (typeReceipt === 2) {
      //         if (type === 1) {
      //           return (
      //             <Badge size="sm" color="blue">
      //               Chi đơn hàng
      //             </Badge>
      //           );
      //         }
      //         return (
      //           <Badge size="sm" color="red">
      //             Chi khác
      //           </Badge>
      //         );
      //       } else if (typeReceipt === 3) {
      //         return (
      //           <Badge size="sm" color="purple" c="#fff">
      //             Điều chỉnh
      //           </Badge>
      //         );
      //       }

      //       return null;
      //     };

      //     return <>{renderBadge()}</>;
      //   },
      // },
      {
        accessorKey: "danh_sach_don_hang",
        enableColumnActions: false,
        enableSorting: false,
        header: "Danh sách đơn hàng",
        accessorFn: (row) => {
          const data = parseAttribute5Data(row)
            .map((item: any) => item.orderNumber ?? item.originalDocumentNumber)
            .filter(Boolean);

          if (data.length === 0) return null;

          return <OrderList orders={data} title="Danh sách đơn hàng" />;
        },
      },
      {
        accessorKey: "orderStatus",
        header: "Trạng thái đơn hàng",
        enableColumnActions: false,
        enableSorting: false,
        size: 200,
        Cell: ({ row }) => {
          const orderStatus = row.original.orderStatus;
          let badgeColor;
          switch (orderStatus) {
            case "DON_HANG_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_CHOT":
              badgeColor = "violet";
              break;
            case "DON_HANG_DOI_TRA_TAM":
              badgeColor = "cyan";
              break;
            case "DON_HANG_HOAN_THANH":
              badgeColor = "green";
              break;
            case "DON_HANG_DOI_TRA":
              badgeColor = "green";
              break;
            case "THANH_TOAN_CHUA_HOAN_THANH":
              badgeColor = "red";
              break;
            case "pending":
              badgeColor = "yellow";
              break;
            case "DON_HANG_BAN_TAI_SHOP":
              badgeColor = "green";
              break;
            case "DON_HANG_CHO_DUYET_GIAM":
              badgeColor = olive_green.light;
              break;
            case "DON_HANG_DA_DUYET_GIAM":
              badgeColor = olive_green.medium;
              break;
            case "DON_CHO_DUYET_DOI_TRA":
              badgeColor = "orange";
              break;
            case "DON_DA_DUYET_DOI_TRA":
              badgeColor = "teal";
              break;
            case "KHO_XUAT_HANG":
              badgeColor = sky_blue.medium;
              break;
            case "DON_HANG_DONG":
              badgeColor = "red";
              break;
            default:
              badgeColor = "gray";
          }
          return (
            <Badge
              size="md"
              color={badgeColor}
              fs={"12,5px"}
              fw={"bold"}
              radius="sm"
            >
              {row.original.orderStatus !== null
                ? getTextStatus(row)
                : "Chưa có đơn hàng"}
            </Badge>
          );
        },
      },
      {
        header: "Người lập Phiếu",
        id: "Nguoilapphieu",
        mantineTableHeadCellProps: () => {
          return {
            style: {
              backgroundColor: "#f1f3f5",
            },
          };
        },
        columns: [
          {
            accessorKey: "creatorbranch",
            enableColumnActions: false,
            header: "Chi nhánh ",
            // Cell: ({ renderedCellValue, cell }) => (
            //   <Text fw={600}>
            //     {renderedCellValue === null ? null : renderedCellValue}
            //   </Text>
            // ),
          },
          {
            accessorKey: "creatorworkplace",
            enableColumnActions: false,
            header: "Địa điểm",
            Cell: ({ renderedCellValue, cell }) => (
              <Text fw={600}>
                {renderedCellValue === "null" ? "" : renderedCellValue}
              </Text>
            ),
            size: 325,
          },
          {
            accessorKey: "creatordepartment",
            enableColumnActions: false,
            header: "Phòng ban ",
            // Cell: ({ renderedCellValue, cell }) => (
            //   <Text fw={600}>{renderedCellValue}</Text>
            // ),
            size: 250,
          },
          {
            accessorKey: "createrolename",
            enableColumnActions: false,
            header: "Chức danh",
            size: 200,
            // Cell: ({ renderedCellValue, cell }) => (
            //   <Text fw={600}>{renderedCellValue}</Text>
            // ),
          },
          {
            accessorKey: "creatorfullname",
            enableColumnActions: false,
            header: "Họ tên",
            size: 225,
            // Cell: ({ renderedCellValue, cell, row }) => (
            //   <>
            //     <Text size="sm">
            //       <AvatarUtils
            //         value={row.original.creatorfullname?.split("-")[0]}
            //       />
            //     </Text>
            //   </>
            // ),
          },
        ],
      },
      {
        accessorKey: "creatorsalesbranch",
        enableColumnActions: false,
        header: "Chi nhánh bán",
        // Cell: ({ renderedCellValue, cell }) => (
        //   <Text fw={600}>
        //     {renderedCellValue === null ? null : renderedCellValue}
        //   </Text>
        // ),
      },
      {
        header: "Người nộp tiền / Người nhận tiền",
        id: "nguoi_nop_tien_nhan_tien",
        mantineTableHeadCellProps: () => {
          return {
            style: {
              backgroundColor: "#f1f3f5",
            },
          };
        },
        columns: [
          {
            accessorKey: "fundbranch",
            enableColumnActions: false,
            header: "Chi nhánh ",
            // Cell: ({ renderedCellValue }) => {
            //   return <Text fw={600}>{renderedCellValue}</Text>;
            // },
          },
          {
            accessorKey: "fundworkplace",
            enableColumnActions: false,
            header: "Địa điểm ",
            Cell: ({ renderedCellValue, cell }) => (
              <Text fw={600}>
                {renderedCellValue === "null" ? "" : renderedCellValue}
              </Text>
            ),
            size: 325,
          },
          {
            accessorKey: "funddepartment",
            enableColumnActions: false,
            header: "Phòng ban ",
            size: 250,
            // Cell: ({ renderedCellValue }) => {
            //   return <Text fw={600}>{renderedCellValue}</Text>;
            // },
          },
          {
            accessorKey: "attribute3",
            enableColumnActions: false,
            header: "Chức danh ",
            // Cell: ({ renderedCellValue, cell }) => {
            //   return <Text fw={600}>{renderedCellValue}</Text>;
            // },
          },
          {
            accessorKey: "funfullname",
            enableColumnActions: false,
            header: "Họ tên ",
            // Cell: ({ renderedCellValue, cell, row }) => (
            //   <>
            //     {row.original.funfullname && (
            //       <AvatarUtils value={row.original.funfullname} />
            //     )}
            //   </>
            // ),
            size: 225,
          },
          // {
          //   accessorKey: "creatorfullname",
          //   enableColumnActions: false,
          //   header: "Nhân viên bán hàng",
          //   Cell: ({ renderedCellValue, cell, row }) => (
          //     <>
          //       <AvatarUtils value={row.original.creatorfullname?.split("-")[0]} />
          //     </>
          //   ),
          // },
        ],
      },
      {
        header: "Khác ",
        id: "khac",
        mantineTableHeadCellProps: () => {
          return {
            style: {
              backgroundColor: "#dee2e6",
            },
          };
        },
        columns: [
          {
            accessorKey: "payertype",
            enableColumnActions: false,
            header: "Loại",
            size: 120,
            Cell: ({ renderedCellValue, row }) => {
              const payerType = row.original.payertype;
              let badgeColor;

              switch (payerType) {
                case "Nhân viên":
                  badgeColor = "#0056D2";
                  break;
                case "Nội bộ":
                  badgeColor = "#FF8800";
                  break;
                case "Khách hàng":
                  badgeColor = "#28A745";
                  break;
                case "NCC":
                  badgeColor = "#ffcc5c";
                  break;
                case "Khác":
                  badgeColor = "#6C757D";
                  break;
                default:
                  badgeColor = "red";
              }

              return (
                <Badge size="sm" color={badgeColor}>
                  {renderedCellValue}
                </Badge>
              );
            },
          },
          {
            accessorKey: "codecustomer",
            enableColumnActions: false,
            header: "Mã",
            size: 120,

            Cell: ({ renderedCellValue, row }) => {
              return (
                <p>
                  {(() => {
                    // const addressItem = addressInfoDetail?.find(
                    //   (item) => String(item.id) === String(renderedCellValue)
                    // );

                    // if (addressItem) {
                    //   return `${addressItem.code} - ${addressItem.buyerName}`;
                    // }

                    // const customerItem = customerDetail?.find(
                    //   (item) => String(item.id) === String(renderedCellValue)
                    // );

                    return renderedCellValue || "";
                  })()}
                </p>
              );
            },
          },
          {
            accessorKey: "anothername",
            enableColumnActions: false,
            header: "Tên",
            // Cell: ({ renderedCellValue, row }) => {
            //   return (
            //     <Text tt="capitalize" fw={600}>
            //       {renderedCellValue}
            //     </Text>
            //   );
            // },
          },
          {
            accessorKey: "phonenumber",
            enableColumnActions: false,
            header: "Số điện thoại",
            size: 150,
            // Cell: ({ renderedCellValue, row }) => {
            //   return (
            //     <Text tt="capitalize" fw={600}>
            //       {renderedCellValue}
            //     </Text>
            //   );
            // },
          },
        ],
      },
      {
        accessorKey: "payerdescription",
        enableColumnActions: false,
        header: "Nội dung",
        size: 400,
        // Cell: ({ renderedCellValue, row }) => {
        //   return (
        //     <Text tt="capitalize" fw={600}>
        //       {renderedCellValue}
        //     </Text>
        //   );
        // },
      },

      {
        header: "Đối tượng công nợ",
        id: "doi_tuong_cong_no",
        mantineTableHeadCellProps: () => {
          return {
            style: {
              backgroundColor: "#f1f3f5",
            },
          };
        },
        columns: [
          {
            accessorKey: "attribute2",
            enableColumnActions: false,
            header: "Mã ",
            size: 110,
            // Cell: ({ renderedCellValue, row }) => {
            //   return (
            //     <Text tt="capitalize" fw={600}>
            //       {renderedCellValue}
            //     </Text>
            //   );
            // },
          },
          {
            accessorKey: "attribute7",
            enableColumnActions: false,
            header: "Tên",
            size: 250,
            // Cell: ({ renderedCellValue, row }) => {
            //   return (
            //     <Text tt="capitalize" fw={600}>
            //       {renderedCellValue}
            //     </Text>
            //   );
            // },
          },
        ],
      },
      {
        accessorKey: "accountfund",
        enableColumnActions: false,
        header: "Loại tiền",
        size: 120,
        Cell: ({ renderedCellValue, row }) => (
          <Text fw={500} size="sm" pl={10}>
            {renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "attribute12",
        enableColumnActions: false,
        header: "Tỉ giá",
        size: 140,
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Math.abs(
                  Number(
                    row.original.accountfund === "VND" ? 1 : renderedCellValue
                  )
                )}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </>
        ),
      },
      {
        accessorKey: "attribute11",
        enableColumnActions: false,
        header: "Số tiền quy đổi",
        Cell: ({ renderedCellValue, cell, row }) => (
          <>
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Math.abs(
                  Number(
                    row.original.accountfund === "VND"
                      ? row.original.totalAmount
                      : renderedCellValue
                  )
                )}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </>
        ),
      },
      {
        header: "Tài khoản nợ / Tài khoản có",
        id: "tai_khoan_no_tai_khoan_co",
        mantineTableHeadCellProps: () => {
          return {
            style: {
              backgroundColor: "#f1f3f5",
            },
          };
        },
        columns: [
          {
            accessorKey: "codefund",
            header: "Mã tài khoản",
            size: 140,
          },
          {
            accessorKey: "attribute6",
            enableColumnActions: false,
            header: "Tên tài khoản",
            size: 350,
          },
        ],
      },
      // {
      //   accessorKey: "Chi_Tiet_Chung_tu",
      //   header: "Chi tiết chứng từ",
      //   Cell: ({ renderedCellValue, row }) => (
      //     <Box pl={20}>
      //       <Text
      //         style={{ cursor: "pointer" }}
      //         c="blue"
      //         fw={500}
      //         fs="italic"
      //         td="underline"
      //         onClick={() => openModal(row.original)}
      //       >
      //         Xem chứng từ
      //       </Text>
      //     </Box>
      //   ),
      // },
      // {
      //   header: "Chi tiết các chứng từ",
      //   id: "Chung_tu",
      //   mantineTableHeadCellProps: () => {
      //     return {
      //       style: {
      //         backgroundColor: "#dee2e6",
      //       },
      //     };
      //   },
      //   columns: [
      //     {
      //       id: "originalDocuments",
      //       header: "Tên chứng từ gốc",
      //       enableColumnActions: false,
      //       enableSorting: false,
      //       accessorFn: (row) => {
      //         const data = parseAttribute5Data(row)
      //           .map((item: any) => item.originalDocuments)
      //           .filter(Boolean);

      //         if (data.length === 0) return null;

      //         return (
      //           <OrderList orders={data} title="Danh sách tên chứng từ gốc" />
      //         );
      //       },
      //       // accessorFn: (row) => {
      //       //   const data = parseAttribute5Data(row)
      //       //     .map((item: any) => item.originalDocuments)
      //       //     .filter(Boolean);

      //       //   return (
      //       //     <>
      //       //       <Tooltip label={data.join(", ")}>
      //       //         <p style={{ margin: 0 }}>{data.join(", ")}</p>
      //       //       </Tooltip>
      //       //     </>
      //       //   );
      //       // },
      //     },
      //     {
      //       id: "originalDocumentNumber",
      //       header: "Số chứng từ gốc",
      //       enableColumnActions: false,
      //       enableSorting: false,
      //       accessorFn: (row) => {
      //         const data = parseAttribute5Data(row)
      //           .map((item: any) => item?.originalDocumentNumber)
      //           .filter(Boolean);

      //         if (data.length === 0) return null;

      //         return (
      //           <OrderList orders={data} title="Danh sách số chứng từ gốc" />
      //         );
      //       },
      //     },
      //   ],
      // },
      // {
      //   id: "codeForFees",
      //   header: "Mã phí",
      //   size: 350,
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.codeForFees)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return <OrderList orders={data} title="Danh sách mã phí" />;
      //   },
      // },
      // {
      //   id: "incurDebt",
      //   header: "Phát sinh nợ",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item.occurringCredit)
      //       .filter(Boolean);

      //     return (
      //       <List fw={600} type="ordered" withPadding>
      //         {data.map((credit: string, index: number) => (
      //           <List.Item key={index}>
      //             <Text fw={600}>
      //               <NumberFormatter
      //                 value={typeKey === 2 || typeKey === 4 ? credit : ""}
      //                 thousandSeparator=","
      //               />
      //             </Text>
      //           </List.Item>
      //         ))}
      //       </List>
      //     );
      //   },
      // },
      // {
      //   id: "occurringCredit",
      //   header: "Phát sinh có / phát sinh nợ",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.occurringCredit)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return <OrderList orders={data} title="Danh sách phát sinh" />;
      //   },
      // },

      // {
      //   id: "branchesFund",
      //   header: "Chi nhánh",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   size: 150,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.branchesFund)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return <OrderList orders={data} title="Danh sách chi nhánh" />;
      //   },
      // },
      // {
      //   id: "employeeFund",
      //   header: "Nhân viên",
      //   size: 200,
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.employeeFund)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return <OrderList orders={data} title="Danh sách nhân viên" />;
      //   },
      // },
      // {
      //   id: "debtObjectCode",
      //   header: "Mã đối tượng công nợ",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.debtObjectCode)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return (
      //       <OrderList orders={data} title="Danh sách mã đối tượng công nợ" />
      //     );
      //   },
      // },
      // {
      //   id: "debtObjectName",
      //   header: "Tên đối tượng công nợ",
      //   size: 400,
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.debtObjectName)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return (
      //       <OrderList orders={data} title="Danh sách tên đối tượng công nợ" />
      //     );
      //   },
      // },
      // {
      //   id: "description",
      //   header: "Nội dung",
      //   size: 400,
      //   enableColumnActions: false,
      //   enableSorting: false,

      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.description)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return <OrderList orders={data} title="Danh sách các nội dung" />;
      //   },
      // },

      // {
      //   id: "fee",
      //   header: "CTKM",
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   size: 130,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.fee)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return (
      //       <OrderList
      //         orders={data}
      //         title="Danh sách các chứng từ khuyến mại"
      //       />
      //     );
      //   },
      // },
      // {
      //   id: "contract",
      //   header: "Hợp Đồng",
      //   size: 130,
      //   enableColumnActions: false,
      //   enableSorting: false,
      //   accessorFn: (row) => {
      //     const data = parseAttribute5Data(row)
      //       .map((item: any) => item?.contract)
      //       .filter(Boolean);

      //     if (data.length === 0) return null;
      //     return <OrderList orders={data} title="Danh sách các hợp đồng" />;
      //   },
      // },
      {
        accessorKey: "attribute8",
        enableColumnActions: false,
        header: "Mã giao dịch",
        size: 150,
        Cell: ({ renderedCellValue, cell }) => (
          <Text fw={600} style={{ paddingLeft: 20 }}>
            {renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "totalAmount",
        enableColumnActions: false,
        header: "Tổng số tiền",
        size: 150,
        Cell: ({ renderedCellValue, cell }) => (
          <Text fw={600}>
            {renderedCellValue !== undefined &&
            !isNaN(Number(renderedCellValue)) ? (
              <NumberFormatter
                value={Math.abs(Number(renderedCellValue))}
                thousandSeparator=","
              />
            ) : (
              <></>
            )}
          </Text>
        ),
      },
      {
        accessorKey: "actions",
        enableColumnActions: false,
        enableSorting: false,
        enableResizing: false,
        header: "Thao tác",
        size: 100,
        Cell: ({ renderedCellValue, row }) => (
          <Flex gap={10}>
            {/* {localStorage.getItem("empId") == "2547" && (
            )} */}
            <Tooltip label="Xem chứng từ">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={() => openModal(row.original)}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon variant="light" aria-label="Settings" color="red">
                <IconTrash
                  onClick={async () => {
                    try {
                      modals.openConfirmModal({
                        title: <Title order={4}>Xác nhận xóa</Title>,
                        children: (
                          <Text size="md" fw={500} mt={15}>
                            Bạn có muốn xóa phiếu !
                          </Text>
                        ),
                        labels: { confirm: "Xác nhận", cancel: "Thoát" },
                        onCancel: () => console.log("Cancel"),
                        onConfirm: async () => {
                          const res = await repositoryPos.get<
                            MessageResponse<boolean>
                          >(
                            `/api/v1/CreateSellItem/delete-receipt?number=${row.original.receiptNumber}`
                          );
                          if (res?.httpStatusCode === 200) {
                            if (res.success) {
                              await fetchData();
                              NotificationExtension.Success("Xóa thành công!");
                            } else NotificationExtension.Fails("Xóa thất bại!");
                          }
                        },
                      });
                    } catch (error) {
                      console.log(error);
                      NotificationExtension.Fails("Thất bại !");
                    }
                  }}
                  size={16}
                />
              </ActionIcon>
            </Tooltip>
          </Flex>
        ),
      },
    ],
    [
      addressInfoDetail,
      customerDetail,
      // dataTblOrderTypeSelect,
      // dataWarehouse,
      // dataCodeFund,
      // //    typeKey,
      // customerOrders,
      //  handleType,
    ]
  );

  const table = useMantineReactTable<PaymentReceiptDetailModel>({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    //add custom action buttons to top-left of top toolbar
    renderTopToolbarCustomActions: ({ table }) => <></>,
    enableStickyHeader: true,
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    localization: _localization,
    enableRowSelection: false,
    // getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT", "receiptNumber", "mrt-row-select"],
        right: ["totalAmount", "actions"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    mantineTableProps: {
      striped: false,
    },
    onRowSelectionChange: setRowSelection,
    manualFiltering: true,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onColumnFiltersChange: setColumnFilters,
    onGlobalFilterChange: setGlobalFilter,
    onPaginationChange: setPagination,
    onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      columnFilters,
      globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "md",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
  });

  const transformToComboboxItem = (item: SelectListItemBase): ComboboxItem => {
    return {
      label: item.text,
      value: item.value,
    };
  };

  const fetchDataCustomer = async (searchTerm: string) => {
    setLoading(true);
    const query = searchTerm ? `KeySearch=${searchTerm}&` : "";
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      `/api/v1/TblDmCustomer/get-select?${query}Skip=${1}&Take=${30}`
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.filter(
        (item: any) => item.text !== null
      );
      setDataListCustomer(filteredData);
      setSkip((prevSkip) => prevSkip + 1);
    }
    setLoading(false);
  };

  const debouncedFetchDataCustomer = React.useCallback((value: string) => {
    if (debounceTimeoutRef.current) {
      clearTimeout(debounceTimeoutRef.current);
    }
    debounceTimeoutRef.current = window.setTimeout(() => {
      fetchDataCustomer(value);
    }, 300);
  }, []);

  // const fetchDataCustomerDetail = async () => {
  //   let url = `?Skip=0&Take=9999`;

  //   try {
  //     // Fetch NCC data
  //     const nccResponse = await repositoryMdm.get(`/api/v1/TblVendor/get-all`);
  //     const nccData = nccResponse?.success ? nccResponse.data : [];

  //     // Map NCC data
  //     const nccMappedData: DepartmentCustomerOrder[] = nccData.map(
  //       (customer: any) => ({
  //         id: customer.id,
  //         name: customer.vendorCode,
  //         details: {
  //           fullName: customer.vendorName,
  //           phoneNumber: customer.phone ?? "",
  //         },
  //       })
  //     );

  //     // Fetch Khách hàng data
  //     const customerResponse = await repositoryPos.get(
  //       `/api/v1/TblDmCustomer/get-list${url}`
  //     );
  //     const customerData = customerResponse?.success
  //       ? customerResponse.data
  //       : [];

  //     // Map Khách hàng data
  //     const customerMappedData: DepartmentCustomerOrder[] = customerData.map(
  //       (customer: any) => ({
  //         id: customer.id,
  //         name: customer.code,
  //         details: {
  //           fullName: customer.name,
  //           phoneNumber: customer.telephoneNumber,
  //         },
  //       })
  //     );

  //     // Combine both NCC and Khách hàng data
  //     const mappedData = [...nccMappedData, ...customerMappedData];
  //     setCustomerOrders(mappedData);
  //   } catch (error) {
  //     console.error("Error fetching customer data:", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchDataCustomerDetail();
  // }, []);

  const fetchDataBranchs = async () => {
    const response = await repositoryPos.get<
      MessageResponse<SelectListItemBase[]>
    >("/api/v1/TblDmInventory/get-select-branch?auth=false");

    if (response && response.success) {
      let result = response.data;
      setDataBranchs(result);
    }
  };

  const fetchDataTblDmCustomer = async () => {
    const response = await repositoryPos.get<MessageResponse<AddressInfo[]>>(
      "/api/v1/TblDmCustomer/get-list?Skip=0&Take=50"
    );

    if (response && response.success) {
      let result = response.data;
      setAddressInfo(result);
    }
  };

  const fetchDataTblVendor = async () => {
    const response = await repositoryMdm.get<MessageResponse<Customer[]>>(
      "/api/v1/TblVendor/get-all"
    );

    if (response && response.success) {
      let result = response.data;
      setCustomerDetail(result);
    }
  };

  // Icon color mappings based on value
  const optionColors: Record<
    "Tiền dư" | "Khác" | "Thanh lý" | "Hoàn ứng công tác" | "Hoàn ứng thu mua",
    string
  > = {
    "Tiền dư": "cyan",
    Khác: "green",
    "Thanh lý": "blue",
    "Hoàn ứng công tác": orange.medium,
    "Hoàn ứng thu mua": purple.medium,
  };

  // Render function to customize the option appearance
  const renderSelectOption: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={
          optionColors[
            option.label as
              | "Tiền dư"
              | "Khác"
              | "Thanh lý"
              | "Hoàn ứng công tác"
              | "Hoàn ứng thu mua"
          ]
        }
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  // account fund
  const optionColorsAccount: Record<"VND" | "USD" | "GOLD", string> = {
    VND: "cyan",
    USD: "green",
    GOLD: orange.medium,
  };

  const dataAccountFund = [
    { value: "VND", label: "VND" },
    { value: "USD", label: "USD" },
    { value: "GOLD", label: "GOLD" },
  ];
  // Render function to customize the option appearance
  const renderSelectOptionAccount: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={optionColorsAccount[option.label as "VND" | "USD" | "GOLD"]}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const TypeTicket: SelectProps["renderOption"] = ({ option, checked }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={option.value === "1" ? "red" : "yellow"}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const renderSelectOptionType: SelectProps["renderOption"] = ({
    option,
    checked,
  }) => (
    <Group flex="1" gap="xs">
      <Badge
        color={option.value === "1" ? "blue" : "green"}
        radius="sm"
        variant="filled"
      >
        {option.label}
      </Badge>
      {checked && <IconCheck style={{ marginInlineStart: "auto" }} />}
    </Group>
  );

  const handleExport = async () => {
    try {
      const search = form.getValues();
      let queryParams = {
        // Skip: pagination.pageIndex * pagination.pageSize,
        // Take: pagination.pageSize,
        CustomerId: search.CustomerId ? search.CustomerId.toString() : "",
        StartDate: search.StartDate
          ? moment(search?.StartDate).format("MM/DD/YYYY")
          : "",
        EndDate: search.EndDate
          ? moment(search?.EndDate).format("MM/DD/YYYY")
          : "",
        KeySearch: search.keySearch
          ? (search.keySearch || keySearch).toLowerCase()
          : "",
        Codefund: search.Codefund ? search.Codefund.toString() : "",
        Accountfund: search.Accountfund ? search.Accountfund.toString() : "",
        Creator: search.Creator ? search.Creator.toString() : "",
        Workplace: search.Workplace ? search.Workplace.toString() : "",
        Branch: search.Branch ? search.Branch.toString() : "",
        Type: search.Type ? search.Type.toString() : "",
        TypeReceipt: search.TypeReceipt ? search.TypeReceipt.toString() : "",
        Department: search.Department ? search.Department.toString() : "",
        OrderStatus: search.OrderStatus ? search.OrderStatus.toString() : "",
      };

      let sortingQuery = "";
      if (sorting && sorting.length > 0) {
        const { id, desc } = sorting[0] || {};
        if (id) {
          sortingQuery = `&sort=${encodeURIComponent(id)}&isOrder=${desc}`;
        }
      }

      const url =
        Object.entries(queryParams).reduce((acc, [key, value]) => {
          if (value !== undefined && value !== "") {
            return `${acc}&${key}=${encodeURIComponent(value)}`;
          }
          return acc;
        }, "/api/v1/CreateSellItem/export-list-receipt?IsBcAll=true") +
        sortingQuery;

      const _url = BASE_API_POS + url;
      const token = localStorage.getItem("token");

      const response = await fetch(_url, {
        method: "GET",
        headers: {
          "Content-Type": "application/vnd.ms-excel",
          Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
        },
      });

      if (!response.ok) {
        throw new Error("Failed to download file");
      }
      const blob = await response.blob();
      const urlss = window.URL.createObjectURL(blob);
      const _name = new Date().toISOString().slice(0, 10);
      let filename = "bao_cao_phieu_thu_chi_" + _name + ".xlsx";
      const link = document.createElement("a");
      link.href = urlss;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  useEffect(() => {
    fetchDataCustomer("");
    fetchDataBranchs();
    fetchDataTblVendor();
    fetchDataTblDmCustomer();
    fetchDataSelect();
    fetchDataBranch();
    fetchDataWarehouse();
  }, []);

  useEffect(() => {
    debouncedFetchDataCustomer(searchTerm);
  }, [searchTerm, debouncedFetchDataCustomer]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (150 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  // useEffect(() => {
  //   if (checkedPinSearch) {
  //     const initSearch = async () => {
  //       await Promise.all([
  //         fetchDataSelect(),
  //         fetchDataBranch(),
  //         fetchDataWarehouse(),
  //       ]);

  //       await SaveKeySearch(search, setSearch, 2);
  //       // 🔹 Cập nhật searchRef với dữ liệu mới từ localStorage
  //       searchRef.current = JSON.parse(
  //         localStorage.getItem("allValueKeySearch") || "{}"
  //       );
  //     };
  //     initSearch();
  //   }
  //   // fetchData();
  // }, [checkedPinSearch]);

  useEffect(() => {
    if (pagination.pageIndex === 0 && data.length < pagination.pageSize) {
      fetchData();
    } else {
      fetchData();
    }
  }, [
    pagination.pageIndex,
    pagination.pageSize,
    sorting,
    // searchRef.current
  ]);

  return (
    <>
      <div
        style={{
          border: "1px solid #dee2e6",
          padding: "10px",
          position: "relative",
        }}
        ref={headerRef}
      >
        <Group gap={0} justify="space-between">
          <_breadcrumb></_breadcrumb>
          <Flex gap={15} align="center" justify="center">
            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // variant="gradient"
                  variant="filled"
                  color="blue"
                  // gradient={{ from: "blue", to: "cyan", deg: 229 }}
                  leftSection={<IconReceipt size={16} />}
                >
                  Thêm phiếu
                </Button>
              </Menu.Target>
              <Menu.Dropdown>
                <Menu.Label>Lập phiếu cho đơn hàng</Menu.Label>
                <Menu.Item
                  onClick={() => {
                    navigate("/bill/payment-receipt");
                  }}
                >
                  Phiếu thu đơn hàng
                </Menu.Item>
                <Menu.Item
                  onClick={() => {
                    navigate("/bill/order-confirmation");
                  }}
                >
                  Phiếu báo có đơn hàng
                </Menu.Item>
                <Menu.Divider />
                <Menu.Label>Phiếu thu chi</Menu.Label>
                <Menu.Item
                  onClick={() => {
                    navigate("/bill/internal-receipt");
                  }}
                >
                  Phiếu thu khác
                </Menu.Item>
                <Menu.Item
                  onClick={() => {
                    navigate("/bill/payment-slip-branches");
                  }}
                >
                  Phiếu chi khác
                </Menu.Item>
                <Menu.Divider />
                <Menu.Label>Phiếu báo nợ, báo có</Menu.Label>
                <Menu.Item
                  onClick={() => {
                    navigate("/bill/credit-advice");
                  }}
                >
                  Phiếu báo có
                </Menu.Item>
                <Menu.Item
                  onClick={() => {
                    navigate("/bill/debt-note-branches");
                  }}
                >
                  Phiếu báo nợ
                </Menu.Item>
              </Menu.Dropdown>
            </Menu>
            <Button
              leftSection={<IconDownload size={14} />}
              color="violet"
              variant="outline"
              onClick={handleExport}
            >
              Xuất Excel
            </Button>
          </Flex>
        </Group>
        <Grid mt={10}>
          <Grid.Col span={{ base: 12, md: 12, lg: 12 }}>
            <Grid>
              <Grid.Col span={sizeGrid}>
                {/* <Input
                  // key={search.keySearch}
                  placeholder="Từ khóa"
                  type="text"
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "keySearch");
                  }}
                  defaultValue={search.keySearch}
                  leftSection={<IconSearch color="#15aabf" />}
                  onKeyDown={async (e) => {
                    if (e.key === "Enter") {
                      await fetchData();
                      localStorage.setItem(
                        "allValueKeySearch",
                        JSON.stringify({
                          ...search,
                          url: String(window.location.pathname),
                        })
                      );
                    }
                  }}
                /> */}
                <TextInput
                  key={form.key("keySearch")}
                  placeholder="Từ khoá"
                  leftSection={<IconSearch color="#15aabf" />}
                  {...form.getInputProps("keySearch")}
                />
              </Grid.Col>
              <Grid.Col
                span={sizeGrid}
                // style={{ flexBasis: "100%", maxWidth: "320px", flex: "1" }}
              >
                {/* <DatePickerInput
                  type="default"
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="sm"
                  placeholder="Từ ngày"
                  locale="vi"
                  //   value={value}
                  valueFormat="DD/MM/YYYY"
                  onChange={(e) => {
                    const startDateFormatted = e
                      ? `${e.getMonth() + 1}/${e.getDate()}/${e.getFullYear()}`
                      : null; // Định dạng MM/DD/YYYY
                    handleChangeSearchValue(
                      startDateFormatted ?? "",
                      "StartDate"
                    );
                  }}
                  clearable
                  value={
                    search.StartDate ? dayjs(search.StartDate).toDate() : null // Nếu không có giá trị, đặt null
                  }
                /> */}
                <DatePickerInput
                  type="default"
                  key={form.key("StartDate")}
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="sm"
                  placeholder="Từ ngày"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  {...form.getInputProps("StartDate")}
                />
              </Grid.Col>
              <Grid.Col
                span={sizeGrid}
                // style={{ flexBasis: "100%", maxWidth: "320px", flex: "1" }}
              >
                {/* <DatePickerInput
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="sm"
                  placeholder="Đến ngày"
                  locale="vi"
                  //  value={value}
                  valueFormat="DD/MM/YYYY"
                  onChange={(e) => {
                    const startDateFormatted = e
                      ? `${e.getMonth() + 1}/${e.getDate()}/${e.getFullYear()}`
                      : null; // Định dạng MM/DD/YYYY
                    handleChangeSearchValue(
                      startDateFormatted ?? "",
                      "EndDate"
                    );
                  }}
                  clearable
                  value={
                    search.EndDate ? dayjs(search.EndDate).toDate() : null // Nếu không có giá trị, đặt null
                  }
                /> */}
                <DatePickerInput
                  key={form.key("EndDate")}
                  leftSection={<IconTimeDuration15 color="#15aabf" />}
                  size="sm"
                  placeholder="Đến ngày"
                  locale="vi"
                  valueFormat="DD/MM/YYYY"
                  {...form.getInputProps("EndDate")}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  key={dataFetch.length || form.key("Department")}
                  searchable
                  clearable
                  placeholder="Phòng ban"
                  limit={50}
                  leftSection={<IconBuildingSkyscraper color="#15aabf" />}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  data={dataFetch
                    .filter((item) => item.text !== "Tất cả")
                    .map((item) => {
                      return {
                        label: item.text ?? "",
                        value: String(item.value ?? ""),
                      };
                    })}
                  // onClick={async () => {
                  //   if (!dataFetch || dataFetch.length < 1) {
                  //     await fetchDataSelect();
                  //   }
                  //   return;
                  // }}
                  {...form.getInputProps("Department")}
                  // onChange={(value) => {
                  //   handleChangeSearchValue(value ?? "", "department");
                  // }}
                  // value={search.department}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  key={dataBranch.length || form.key("Branch")}
                  searchable
                  clearable
                  placeholder="Chi nhánh"
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  limit={50}
                  leftSection={<IconBrandBootstrap color="#15aabf" />}
                  data={dataBranch.map((item) => {
                    return {
                      label: item.text ?? "",
                      value: String(item.value ?? ""),
                    };
                  })}
                  // onClick={async () => {
                  //   if (!dataBranch || dataBranch.length < 1) {
                  //     await fetchDataBranch();
                  //   }
                  //   return;
                  // }}
                  {...form.getInputProps("Branch")}
                  // onChange={(value) => {
                  //   handleChangeSearchValue(value ?? "", "branch");
                  // }}
                  // value={search.branch}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  key={dataWarehouse.length || form.key("Creator")}
                  searchable
                  clearable
                  placeholder="Nhân viên"
                  leftSection={<IconUser color="#15aabf" />}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  limit={50}
                  data={dataWarehouse.map((item) => {
                    return {
                      label: item.att1 + " - " + item.text,
                      value: String(item.value ?? ""),
                    };
                  })}
                  // onClick={async () => {
                  //   if (!dataWarehouse || dataWarehouse.length < 1) {
                  //     await fetchDataWarehouse();
                  //   }
                  //   return;
                  // }}
                  {...form.getInputProps("Creator")}
                  // onChange={(value) => {
                  //   handleChangeSearchValue(value ?? "", "creator");
                  // }}
                  // value={search.creator}
                />
              </Grid.Col>
              {/* <Grid.Col span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Mã phí"
                  leftSection={<IconReceipt color="#15aabf" />}
                  limit={50}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  data={transformedData}
                  onChange={(value) => {
                    handleChangeSearchValue(value ?? "", "codefund");
                  }}
                  // renderOption={renderSelectOption}
                />
              </Grid.Col> */}
              <Grid.Col span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Tài khoản quỹ"
                  leftSection={<IconCoinPound color="#15aabf" />}
                  limit={50}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  key={form.key("Accountfund")}
                  data={dataAccountFund}
                  // onChange={(value) => {
                  //   handleChangeSearchValue(value ?? "", "Accountfund");
                  // }}
                  {...form.getInputProps("Accountfund")}
                  renderOption={renderSelectOptionAccount}
                />
              </Grid.Col>
              {/* <Grid.Col span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Chọn danh sách phiếu"
                  leftSection={<IconTicket color="#15aabf" />}
                  limit={50}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  data={[
                    { value: "1", label: "Danh sách phiếu thu / chi" },
                    { value: "2", label: "Danh sách phiếu chi" },
                  ]}
                  onChange={(value) => {
                    handleChangeSearchValue(value ?? "", "Type");
                    handelType(Number(value));
                  }}
                  renderOption={TypeTicket}
                />
              </Grid.Col> */}

              <Grid.Col span={sizeGrid}>
                <Select
                  key={form.key("TypeReceipt")}
                  searchable
                  clearable
                  placeholder="Loại phiếu"
                  leftSection={<IconTicket color="#15aabf" />}
                  limit={50}
                  comboboxProps={{
                    transitionProps: { transition: "pop", duration: 200 },
                  }}
                  data={[
                    { value: "1", label: "Thu" },
                    { value: "2", label: "Chi" },
                    // { value: "1", label: "Phiếu chi" },
                    // { value: "2", label: "Phiếu báo nợ" },
                  ]}
                  {...form.getInputProps("TypeReceipt")}
                  // value={search.typeReceipt}
                  // onChange={(value) => {
                  //   handleChangeSearchValue(value ?? "", "TypeReceipt");
                  // }}
                  renderOption={renderSelectOptionType}
                />
              </Grid.Col>
              <Grid.Col span={sizeGrid}>
                <Select
                  searchable
                  clearable
                  placeholder="Trạng thái đơn hàng"
                  leftSection={<IconStatusChange color="#15aabf" />}
                  limit={50}
                  key={form.key("OrderStatus")}
                  // value={search.type}
                  data={orderStatuses}
                  {...form.getInputProps("OrderStatus")}

                  // onChange={(value) => {
                  //   handleChangeSearchValue(value ?? "", "type");
                  // }}
                  //     renderOption={renderSelectOptionType}
                />
              </Grid.Col>

              <Grid.Col span={sizeGrid}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                    // localStorage.setItem(
                    //   "allValueKeySearch",
                    //   JSON.stringify({
                    //     ...search,
                    //     url: String(window.location.pathname),
                    //   })
                    // );
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
              <Grid.Col
                span={sizeGrid}
                style={{ alignItems: "center", display: "flex" }}
              >
                <Flex gap={20} justify="center" align="center">
                  <Text
                    style={{ whiteSpace: "nowrap" }}
                    c="red"
                    fw={800}
                    flex="0 0 50px"
                  >
                    Tổng kết số tiền:
                  </Text>
                  <Text c="red" fw={800}>
                    <NumberFormatter
                      value={
                        data.reduce(
                          (total, item) => total + item.totalAmount,
                          0
                        ) ?? 0
                      }
                      thousandSeparator=","
                    />
                  </Text>
                </Flex>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};
export default NewspaperListAvailable;
